import { render } from "./twitter.svg?vue&type=template&id=281c3270"
const script = {}
script.render = render

export default script